export const RESOURCE_SHARE_REDUCER_PATH = "lenderResourceShareApi";

export const RESOURCE_SHARE_SERVICE_TAG = "ResourceShare";

export const RESOURCE_SHARE_RELATED_TAGS = [RESOURCE_SHARE_SERVICE_TAG];

